import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const http = axios.create({ baseURL: API });

export const TOKEN_KEY = "gpsv_token";

export function setToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
    http.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    localStorage.removeItem(TOKEN_KEY);
    delete http.defaults.headers.common.Authorization;
  }
}

const _t = localStorage.getItem(TOKEN_KEY);
if (_t) http.defaults.headers.common.Authorization = `Bearer ${_t}`;

http.interceptors.response.use(
  (r) => r,
  (error) => {
    const url = error.config?.url || "";
    if (error.response?.status === 401 && !url.includes("/auth/login")) {
      setToken(null);
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

const api = {
  // auth
  login: (username, password) => http.post("/auth/login", { username, password }).then((r) => r.data),
  me: () => http.get("/auth/me").then((r) => r.data),
  logout: () => http.post("/auth/logout").then((r) => r.data),
  changePassword: (currentPassword, newPassword) =>
    http.post("/auth/change-password", { currentPassword, newPassword }).then((r) => r.data),
  // app
  getSettings: () => http.get("/settings").then((r) => r.data),
  updateSettings: (data) => http.put("/settings", data).then((r) => r.data),
  generateKey: (data) => http.post("/transferz/generate-key", data).then((r) => r.data),
  testConnection: () => http.post("/transferz/test").then((r) => r.data),
  syncNow: () => http.post("/journeys/sync").then((r) => r.data),
  cleanupJourneys: () => http.post("/journeys/cleanup").then((r) => r.data),
  importJourney: (value) => http.post("/journeys/import", { value }).then((r) => r.data),
  listJourneys: () => http.get("/journeys").then((r) => r.data),
  getJourney: (id) => http.get(`/journeys/${id}`).then((r) => r.data),
  refreshJourney: (id) => http.post(`/journeys/${id}/refresh`).then((r) => r.data),
  toggleAutomation: (id, enabled) => http.patch(`/journeys/${id}/automation`, { enabled }).then((r) => r.data),
  manualStep: (id, step) => http.post(`/journeys/${id}/step`, { step }).then((r) => r.data),
  assignJourney: (id, data = {}) => http.post(`/journeys/${id}/assign`, data).then((r) => r.data),
  getLogs: (limit = 100) => http.get(`/logs?limit=${limit}`).then((r) => r.data),
  getStats: () => http.get("/stats").then((r) => r.data),
};

export { http };
export default api;
